import React from 'react';
import { toaster, ToasterOptionsType } from '@fiverr-private/fit';
import StatusToast from '../..';
import { StatusToastProps } from '../../types';
import { DEFAULT_DURATION } from './constants';

export interface raiseProps extends StatusToastProps, ToasterOptionsType {}

const raise = ({
    message,
    className,
    theme,
    duration = DEFAULT_DURATION,
    location = 'top-center'
}: raiseProps) =>
    toaster.raise(
        <StatusToast className={className} message={message} theme={theme}/>,
        { duration, location }
    );

export default raise;
